var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferReviewComparisonGaugeSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "offer_review_gauge_solar_fill",
    x1: 1,
    y1: 1,
    x2: 0,
    y2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20AC87",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#06E775",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06E775",
    stopOpacity: 0.1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.742,
    cy: 83.6873,
    r: 83.0877,
    fill: "url(#offer_review_gauge_solar_fill)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.229187 83.6873C0.229187 129.575 37.6176 166.775 83.7386 166.775C129.86 166.775 167.248 129.575 167.248 83.6873C167.248 37.7992 129.86 0.599609 83.7386 0.599609C37.6176 0.599609 0.229187 37.7992 0.229187 83.6873ZM163.073 83.6873C163.073 127.281 127.554 162.621 83.7386 162.621C39.9237 162.621 4.40466 127.281 4.40466 83.6873C4.40466 40.0936 39.9237 4.75399 83.7386 4.75399C127.554 4.75399 163.073 40.0936 163.073 83.6873Z",
    fill: "#32A071",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferReviewComparisonGaugeSolar);
export default __webpack_public_path__ + "static/media/offer-review-comparison-gauge-solar.b529ec3c9b9a0c1589d19a0b452c19e4.svg";
export { ForwardRef as ReactComponent };